module.exports = __webpack_public_path__ + "static/img/d-sperse-tech.11096898.png";